const CustomRefLine = ({ viewBox, range }) => {
  const { x, y } = viewBox;

  return (
    <text
      x={"55%"}
      y={y - 8}
      fill="#008435"
      fontSize="10px"
      fontWeight="bold"
      textAnchor="middle"
    >
      Normal range: {range}
    </text>
  );
};

export default CustomRefLine;
